module.exports = "page-container{display:block}\n"